/* Sizes to the badge, so the tooltip anchors on the pill and the focus ring follows its outline. */
.slot {
  display: inline-flex;
  border-radius: var(--border-radius__sm);
}
